// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test'
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeAutoCompleteResizeMenu = function() {};

	// Fix conflict with theme's cart
	jQ(Selector.otpTopCartLink).on('click', function() {
		if(jQ('.boost-pfs-minicart-wrapper').length > 0) {
			jQ('#ajaxifyModal').hide();
			jQ('#ajaxifyCart-overlay').hide();
		}
	})
    

})();

// Custom auto-suggest
(function () {
  if (typeof BoostPFS === 'undefined' || typeof BoostPFS.inject !== 'function') return;
  if (window.teDropdownFollowsRedirects) return;
  window.teDropdownFollowsRedirects = true;

  var Boost = {};
  BoostPFS.inject(Boost);

  var Api = Boost.InstantSearchApi;
  var SearchInput = Boost.SearchInput;
  var ViewAll = Boost.InstantSearchResultBlockViewAll;
  if (!Api || !SearchInput || !ViewAll || typeof window.fetch !== 'function') return;

  var TIMEOUT_MS = 2500;
  var latestTerm = '';

  function norm(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function sameStore(url) {
    return url.hostname.replace(/^www\./, '') === window.location.hostname.replace(/^www\./, '');
  }

  function valueOf(list, key) {
    if (!list || !list.length) return '';
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].key === key) return list[i].values;
    }
    return '';
  }

  function searchQueryFrom(redirect) {
    try {
      var url = new URL(redirect, window.location.origin);
      if (!sameStore(url) || !/(^|\/)search\/?$/.test(url.pathname)) return '';
      return (url.searchParams.get('q') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function linkFor(redirect) {
    try {
      var url = new URL(redirect, window.location.origin);
      return sameStore(url) ? url.pathname + url.search + url.hash : url.href;
    } catch (e) {
      return redirect;
    }
  }

  var originalSource = SearchInput.prototype._bindAutoCompleteSource;
  SearchInput.prototype._bindAutoCompleteSource = function (request) {
    latestTerm = norm(request && request.term);
    return originalSource.apply(this, arguments);
  };

  function fetchRedirectProducts(query) {
    var params = Api.prepareSuggestionParams(query, 'suggest_dym');
    delete params.callback;
    var base = (window.boostPFSConfig && boostPFSConfig.api && boostPFSConfig.api.suggestionUrl) ||
      'https://services.mybcapps.com/bc-sf-filter/search/suggest';
    var url = base + '?q=' + encodeURIComponent(query) + '&' + Boost.jQ.param(params);

    var request = window.fetch(url, { credentials: 'omit' }).then(function (response) {
      if (!response.ok) throw new Error('Boost suggest ' + response.status);
      return response.json();
    });
    var timeout = new Promise(function (resolve, reject) {
      setTimeout(function () { reject(new Error('timeout')); }, TIMEOUT_MS);
    });
    return Promise.race([request, timeout]);
  }

  var previousAfterCallAsync = Api.afterCallAsync;
  Api.afterCallAsync = function (data, next) {
    function proceed(result) {
      if (typeof previousAfterCallAsync === 'function') previousAfterCallAsync(result, next);
      else next(result);
    }

    try {
      if (!data || data.prev_query || !data.redirect) return proceed(data);
      var target = searchQueryFrom(data.redirect);
      var asked = norm(data.query);
      if (!target || norm(target) === asked) return proceed(data);

      fetchRedirectProducts(target).then(function (redirected) {
        if (latestTerm && asked && latestTerm !== asked) return;
        if (redirected && Array.isArray(redirected.products) && redirected.products.length) {
          Api.setDefaultValueForExcludedFields(redirected);
          data.products = redirected.products;
          data.total_product = redirected.total_product;
        }
        proceed(data);
      }).catch(function () {
        proceed(data);
      });
    } catch (e) {
      proceed(data);
    }
  };

  var originalCompile = ViewAll.prototype.compileTemplate;
  ViewAll.prototype.compileTemplate = function () {
    var html = originalCompile.apply(this, arguments);
    try {
      var redirect = valueOf(this.data, 'redirect');
      if (html && redirect) {
        var href = linkFor(redirect).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
        html = html.replace(/href="[^"]*"/, 'href="' + href + '"');
      }
    } catch (e) {}
    return html;
  };
})();
